"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WIDGET_ORIGIN_URL = exports.WIDGET_BACKGROUND_BY_PALETTE_NAME = exports.STAGES = exports.DEFAULT_MAX_WIDTH = exports.DEFAULT_HEIGHT = void 0;
var DEFAULT_HEIGHT = '625px';
exports.DEFAULT_HEIGHT = DEFAULT_HEIGHT;
var DEFAULT_MAX_WIDTH = '800px';
exports.DEFAULT_MAX_WIDTH = DEFAULT_MAX_WIDTH;
var STAGES = {
  LOCAL: 'LOCAL',
  DEV: 'DEV',
  QA: 'QA',
  STG: 'STG',
  PROD: 'PROD'
};
exports.STAGES = STAGES;
var WIDGET_BACKGROUND_BY_PALETTE_NAME = {
  "default": '#FFF',
  clementine: '#F2F5F7',
  neptune: '#F3F3F3',
  cosmo: '#323232'
};
exports.WIDGET_BACKGROUND_BY_PALETTE_NAME = WIDGET_BACKGROUND_BY_PALETTE_NAME;
var WIDGET_ORIGIN_URL = {
  DEV: 'http://s3-dev-bz-ui.s3-website-us-east-1.amazonaws.com/apps/web/bz-rfq-ui-prerendered',
  LOCAL: 'http://localhost:8000',
  PROD: 'https://app.buyerzone.com',
  QA: 'http://s3-dev-bz-ui.s3-website-us-east-1.amazonaws.com/apps/web/bz-rfq-ui-prerendered',
  STG: 'https://app-stg.buyerzone.com'
};
exports.WIDGET_ORIGIN_URL = WIDGET_ORIGIN_URL;